<template>
  <span @keydown.enter.prevent="">
    <v-autocomplete
      ref="autocompleteRef"
      v-click-outside="handleClickOutside"
      :value="value"
      :label="label"
      :placeholder="placeholder"
      :disabled="disabled"
      :items="items"
      :item-text="itemRender"
      :item-value="itemSelect"
      :dense="dense"
      :loading="loading"
      :return-object="returnObject"
      :value-comparator="valueComparator"
      :no-data-text="noDataText"
      :cache-items="onSearchChange && multiple"
      :filter="filter"
      :no-filter="noFilter"
      filled
      small-chips
      height="56"
      :multiple="multiple"
      :search-input.sync="search"
      box
      :error-messages="getErrors(validator)"
      @input="$emit('input', $event) && validator && validator.$touch()"
      @blur="validator && validator.$touch()"
      @change="$emit('change', $event)"
    >
      <template v-if="$scopedSlots.selection" v-slot:selection="data">
        <slot name="selection" :item="data.item" />
      </template>
      <template v-if="$scopedSlots.item" v-slot:item="{ item }">
        <slot name="item" :item="item" />
      </template>
      <template v-if="$slots['no-data']" v-slot:no-data>
        <slot name="no-data" />
      </template>
    </v-autocomplete>
  </span>
</template>

<script>

import { defaultMessages, getValidationErrors } from './../../../utils'

export default {
  name: 'autocomplete-field',
  props: {
    disabled: Boolean,
    placeholder: {
      type: String,
      default: null,
    },
    chips: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: null,
    },
    value:{
      type: [String, Number, Object, Array],
      default: null,
    },
    items: {
      type: Array,
      default: () =>[],
    },
    itemRender: {
      type: String,
      default: null,
    },
    itemSelect: {
      type: String,
      default: null,
    },
    validator: {
      type: Object,
      default: null,
    },
    errorMessages: {
      type: Object,
      default: null,
    },
    valueComparator: {
      type: Function,
      default: undefined,
    },
    loading: Boolean,
    dense: Boolean,
    noDataText: String,
    filter: Function,
    noFilter: Boolean,
    multiple: Boolean,
    returnObject: Boolean,
    onSearchChange: {
      type: Function,
      default: () => null,
    },
  },
  data() {
    return {
      search: this.onSearchChange && '',
    }
  },
  watch: {
    search(value) {
      this.onSearchChange(value)
    },
  },
  methods: {
    handleClickOutside() {
      this.$refs.autocompleteRef.isMenuActive = false
    },
    getErrors: function(field){
      return getValidationErrors({
        ...defaultMessages,
        ...this.errorMessages,
      })(field)
    },
  },
}
</script>

<style>
</style>
